import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { z } from "zod";
import { SearchEverything } from "@/client/components/search-everything";
import { clientCopy } from "@/client/copy";
import { pageTitle } from "@/client/lib/page-title";

const DEFAULTS = { q: "", show: "all" } as const;

const searchPageSearch = z.object({
  q: z.string().max(200).catch(DEFAULTS.q).default(DEFAULTS.q),
  show: z
    .enum(["all", "tasks", "comments", "projects"])
    .catch(DEFAULTS.show)
    .default(DEFAULTS.show),
});

export const Route = createFileRoute("/_authenticated/$slug/search")({
  head: ({ match }) => ({
    meta: [
      { title: pageTitle(clientCopy.search.label, match.context.companyName) },
    ],
  }),
  validateSearch: searchPageSearch,
  search: { middlewares: [stripSearchParams(DEFAULTS)] },
  component: SearchEverything,
});
